(function (d, w, $) {
    "use strict";

    var app;
    var onready;
    var onload;
    var $w = $(w);
    var $d = $(d);
    var $b = $(d.body);
    var $header = $(d.getElementById("header"));
    var $content = $(d.getElementById("content"));
    var $main = $(d.getElementById("main"));
    // var $footer = $(d.getElementById("footer"));
    var controller = new ScrollMagic.Controller();

    app = {
        vars: {},
        jrespond: (function () {
            var css = $("head").css("font-family").replace(/^"?|"?$|\\/g, "").split(","),
                bps = [],
                bp,
                i;

            for (i = 0; i < css.length; i += 1) {
                bp = css[i].trim().split(' ');
                bps.push({
                    label: bp[0],
                    enter: parseInt(bp[1], 10),
                    exit: parseInt(bp[2], 10)
                });
            }

            return jRespond(bps);
        }()),
        cookie: (function () {
            var set = function (name, value, options) {
                    options = options || {};

                    return d.cookie = [
                        name + "=" + encodeURIComponent(value),
                        options.expires ? "; expires=" + new Date(new Date().getTime() + (options.expires * 24 * 60 * 60 * 1000)).toUTCString() : "",
                        options.path ? "; path=" + options.path : ""
                    ].join("");
                },
                map = function () {
                    var map_cookies = {},
                        cookies = d.cookie.split('; '),
                        cookie,
                        i;

                    for (i = 0; i < cookies.length; i += 1) {
                        cookie = cookies[i].split('=');
                        map_cookies[cookie[0]] = decodeURIComponent(cookie[1]);
                    }

                    return map_cookies;
                },
                get = function (name) {
                    return this.map()[name];
                },
                remove = function (name, options) {
                    return this.set(name, '', $.extend({}, options, {expires: -1}));
                };

            return {
                set: set,
                map: map,
                get: get,
                remove: remove
            };
        }()),
        scrollto: (function () {
            var $anchors = $("[data-anchor]"),
                hash = w.location.hash;

            function scrollto(el, offset) {
                var target,
                    $target;

                if (el.target) {
                    if ($(el.target).data("scrollto") !== undefined) {
                        target = $(el.target).data("scrollto");
                    } else if (el.target.pathname && el.target.hostname && w.location.pathname.replace(/^\//, "") === el.target.pathname.replace(/^\//, "") && w.location.hostname === el.target.hostname) {
                        target = el.target.hash;
                    }
                } else {
                    target = el;
                }

                if ($(target).length) {
                    $target = $(target);
                } else if ($("[data-anchor='" + target + "']").length) {
                    $target = $("[data-anchor='" + target + "']");
                }
                if (!target || !$target || !$target.length) {
                    return;
                }

                offset = offset || 0;
                if ($target.data("scrollto-offset") !== undefined) {
                    offset = parseInt($target.data("scrollto-offset"), 10);
                } else if (el.target && $(el.target).data("scrollto-offset") !== undefined) {
                    offset = parseInt($(el.target).data("scrollto-offset"), 10);
                }

                if (w.scroll) {
                    w.scroll({
                        top: $target.offset().top - offset,
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    $("body, html").animate({
                        scrollTop: $target.offset().top - offset
                    }, 500);
                }

                return true;
            }

            $d.on("click.scrollto scrollto", "[data-scrollto], a[href*='#']:not([href$='#']):not([data-target]):not(.popup--inline)", function (e) {
                if (scrollto(e)) {
                    e.preventDefault();
                }
            });
            $d.on("anchor", "[data-anchor]", function () {
                if ($(this).data("anchor") !== undefined) {
                    scrollto(this);
                }
            });
            $w.on("load", function () {
                if (hash && $anchors.length) {
                    $anchors.each(function () {
                        if ($(this).attr("data-anchor") === hash) {
                            $(this).trigger("anchor");
                        }
                    });
                }
            });

            return scrollto;
        }()),
        debounce: function (fn, threshold) {
            var timeout;

            return function () {
                var that = this,
                    args = arguments;

                clearTimeout(timeout);

                timeout = setTimeout(function () {
                    fn.apply(that, args);
                }, threshold || 100);
            };
        },
        before: function () {
            app.vars.switch = {};

            $d.on("switch switch:open switch:close", function (e, data) {
                var params = {
                    target: d.body
                };

                if (typeof data === "object") {
                    $.extend(params, data);
                } else {
                    params.name = data;
                }

                params.class = params.name + "--open";
                params.open = !app.vars.switch[params.name];

                $d.trigger({
                    type: "switch:before",
                    namespace: params.name,
                    switch: params,
                    target: e.target
                });

                switch (e.type) {
                    case "open":
                        $(params.target).addClass(params.class);
                        break;
                    case "close":
                        $(params.target).removeClass(params.class);
                        break;
                    default:
                        $(params.target).toggleClass(params.class);
                }

                app.vars.switch[params.name] = $(params.target).hasClass(params.class);
                params.open = !!app.vars.switch[params.name];

                $d.trigger({
                    type: "switch:after",
                    namespace: params.name,
                    switch: params,
                    target: e.target
                });
            });

            $d.on("click.switch", "[data-switch]", function (e) {
                var data = $(this).data("switch");
                var params = {
                    prevent: true
                };

                if (typeof data === "string") {
                    params.name = data;
                } else {
                    $.extend(params, data);
                }

                if (params.prevent) {
                    e.preventDefault();
                }
                delete params.prevent;

                $d.trigger({
                    type: "switch",
                    target: this
                }, params);
            });

            w.addEventListener("beforeunload", function (e) {
                if (app.vars.sending) {
                    e.returnValue = "";
                    e.preventDefault();
                }
            });
        },
        after: function () {
            if (typeof $.fn.parallax === "function") {
                $(".js-parallax").parallax();
            }
            if (typeof $.fn.toggler === "function") {
                $(".js-toggler").toggler();
            }
        },
        swiper: (function () {
            var defaults = {
                // initialSlide: 0,
                // direction: "horizontal",
                speed: 1000,
                // virtualTranslate: false,
                // autoHeight: false,
                // roundLengths: false,
                // nested: false,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                // spaceBetween: 0,
                // slidesPerView: 1,
                // slidesPerColumn: 1,
                // slidesPerColumnFill: 'column',
                // slidesPerGroup: 1,
                // centeredSlides: false,
                // slidesOffsetBefore: false,
                // slidesOffsetAfter: false,
                // normalizeSlideIndex: true,
                grabCursor: true,
                // touchRatio: 1,
                // touchAngle: 45,
                // simulateTouch: true,
                // shortSwipes: true,
                // longSwipes: true,
                // longSwipesRatio: 0.5,
                // longSwipesMs: 300,
                // followFinger: true,
                // allowTouchMove: true,
                // threshold: 0,
                // touchMoveStopPropagation: true,
                // touchReleaseOnEdges: false,
                // passiveListeners: true,
                // resistance: true,
                // resistanceRatio: 0.85,
                // preventClicks: true,
                // preventClicksPropagation: true,
                // slideToClickedSlide: false,
                // watchSlidesProgress: false,
                // watchSlidesVisibility: false,
                loop: true,
                // loopAdditionalSlides: 0,

                play: false,
                hash: false,
                pager: false,
                buttons: false,
                external: false,
                keyboard: false,
                progressbar: false
            };

            function paginationToggle(s) {
                if (!s.options.pager || !s.options.pagination.el.length) {
                    return;
                }

                if ((s.obj.params.slidesPerView !== "auto" && s.obj.slides.length > s.obj.params.slidesPerView) || (s.obj.params.slidesPerView === "auto" && s.obj.width < s.obj.virtualSize)) {
                    s.options.pagination.el.show();
                } else {
                    s.options.pagination.el.hide();
                }
            }

            function slideTo(s, hash) {
                if (s.hash.indexOf(hash) > -1) {
                    s.obj.slideTo($(".swiper-slide[data-hash='" + hash + "']", s.cont).index());
                }
            }

            return {
                init: function (el) {
                    var swiper = {
                        cont: $(".swiper-container", el)[0],
                        hash: []
                    };

                    if (!el || !$(el).length || typeof Swiper !== "function") {
                        return false;
                    } else if (swiper.cont.swiper) {
                        return swiper.cont.swiper;
                    }

                    swiper.data = $(swiper.cont).data("swiper-options") || {};
                    swiper.options = $.extend({}, defaults, swiper.data);

                    if (swiper.options.play) {
                        swiper.options.autoplay = {
                            delay: swiper.options.play,
                            // stopOnLast: false,
                            disableOnInteraction: false,
                            pauseOnHover: true
                        };
                    }
                    if (swiper.options.hash) {
                        swiper.options.hashNavigation = {
                            watchState: true,
                            replaceState: true
                        };
                    }
                    if (swiper.options.pager) {
                        swiper.options.pagination = {
                            el: $(".swiper-pagination", el),
                            clickable: true
                        };
                        if (["bullets", "fraction"].indexOf(swiper.options.pager) >= 0) {
                            swiper.options.pagination.type = swiper.options.pager;
                        }
                        swiper.options.pagination.el[$(".swiper-slide", el).length === 1 ? "hide" : "show"]();
                    }
                    if (swiper.options.buttons) {
                        swiper.options.navigation = {
                            prevEl: $(".swiper-button-prev", el)[0],
                            nextEl: $(".swiper-button-next", el)[0]
                        };
                        $(".swiper-buttons", el).show();
                    }

                    $(".swiper-wrapper", el).children().addClass("swiper-slide");

                    swiper.obj = new Swiper(swiper.cont, swiper.options);

                    if (swiper.options.play && swiper.options.autoplay.delay && swiper.options.autoplay.delay > 0 && swiper.options.autoplay.pauseOnHover) {
                        $(swiper.cont).on({
                            "mouseenter.swiper": swiper.obj.autoplay.stop,
                            "mouseleave.swiper": swiper.obj.autoplay.start
                        });
                    }

                    $w.on("resize.swiper-resize", function () {
                        paginationToggle(swiper);
                    });

                    if (swiper.options.external && $(swiper.options.external).length) {
                        $(".swiper-slide", el).map(function () {
                            if ($(this).attr("data-hash") !== undefined) {
                                swiper.hash.push($(this).attr("data-hash"));
                            }
                        });

                        swiper.obj.on("transitionStart", function () {
                            $("a[href^='#" + $(".swiper-slide", el).eq(swiper.obj.activeIndex).attr("data-hash") + "']", swiper.options.external)
                                .parent("li")
                                .addClass("active")
                                .siblings("li")
                                .removeClass("active");
                        });
                        $(".swiper-slide", el).on("onScrollTo", function () {
                            slideTo(swiper, $(this).attr("data-hash"));
                        });
                        if (w.location.hash && $("a[href='" + w.location.hash + "']", swiper.options.external).length) {
                            slideTo(swiper, w.location.hash.slice(1));
                        }
                        $w.on("hashchange", function () {
                            slideTo(swiper, w.location.hash.slice(1));
                        });
                    }

                    $(el).on("update", function () {
                        swiper.obj.update();
                        swiper.obj.slideTo(0, 0);
                    });

                    return swiper.obj;
                },
                onready: function () {
                    var $swiper = $(".swiper");

                    if (!$swiper.length) {
                        return;
                    }

                    $swiper.each(function () {
                        app.swiper.init(this);
                    });
                }
            };
        }()),
        popup: (function () {
            var galleries = {};

            return {
                setup: (function () {
                    if (typeof $.magnificPopup !== "object") {
                        return;
                    }

                    $.extend(true, $.magnificPopup.defaults, {
                        tClose: 'Zamknij',
                        closeMarkup: '<button type="button" title="%title%" class="mfp-close btn-close"></button>',
                        tLoading: 'Ładowanie...',
                        gallery: {
                            tPrev: 'Poprzednia',
                            tNext: 'Następna',
                            tCounter: "%curr% z %total%",
                            arrowMarkup: '<button type="button" title="%title%" class="mfp-arrow mfp-arrow-%dir% btn-%dir%"></button>'
                        },
                        image: {
                            tError: "<a href=\"%url%\">Grafika</a> nie może zostać załadowana."
                        },
                        ajax: {
                            tError: "<a href=\"%url%\">Treść</a> nie może zostać załadowana."
                        }
                    });

                    $('[data-popup]').on('click.popup', function (e) {
                        var $this = $(this);

                        $.magnificPopup.open({
                            mainClass: 'mfp-nobg',
                            showCloseBtn: false,
                            items: {
                                src: '<div class="mfp-loading"><span>' + $.magnificPopup.defaults.tLoading + '</span></div>',
                                type: 'inline'
                            },
                            callbacks: {
                                open: function () {
                                }
                            }
                        });

                        $.ajax({
                            url: 'ajax',
                            type: "POST",
                            data: {
                                action: "popup",
                                popup: $this.data('popup')
                            },
                            // beforeSend: function () {},
                            success: function (response) {
                                var magnificpopup = $.magnificPopup.instance;

                                if (magnificpopup && magnificpopup.currTemplate) {
                                    $.magnificPopup.close();
                                    $.magnificPopup.open({
                                        mainClass: 'mfp-anim',
                                        showCloseBtn: true,
                                        closeBtnInside: false,
                                        closeOnBgClick: false,
                                        removalDelay: 400,
                                        callbacks: {
                                            beforeOpen: function () {
                                                if (this.st.el.attr('data-popup-class')) {
                                                    this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-popup-class');
                                                }
                                            }
                                        },
                                        items: {
                                            src: response.html,
                                            type: 'inline'
                                        }
                                    });
                                }
                            }
                        });

                        e.preventDefault();
                    });
                }()),
                popup: function () {
                    if (typeof $.magnificPopup !== "object") {
                        return;
                    }

                    $(".popup:not(.popup--youtube):not(.popup--iframe):not(.popup--inline)").magnificPopup({
                        mainClass: 'mfp-anim',
                        type: "image",
                        closeBtnInside: true,
                        removalDelay: 400,
                        callbacks: {
                            beforeOpen: function () {
                                if (this.st.el.attr('data-popup-class')) {
                                    this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-popup-class');
                                }
                            }
                        }
                    });
                    $(".popup.popup--youtube").magnificPopup({
                        type: "iframe",
                        closeBtnInside: true
                    });
                    $(".popup.popup--iframe").magnificPopup({
                        type: "iframe",
                        closeBtnInside: true,
                        fixedContentPos: false
                    });
                    $(".popup.popup--inline").magnificPopup({
                        mainClass: 'mfp-anim',
                        closeBtnInside: true,
                        closeOnBgClick: false,
                        removalDelay: 400,
                        enableEscapeKey: false,
                        callbacks: {
                            beforeOpen: function () {
                                if (this.st.el.attr('data-popup-class')) {
                                    this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-popup-class');
                                }
                            },
                            change: function (item) {
                                $(".mfp-close", item.inlineElement).insertBefore(item.inlineElement);
                            },
                            close: function () {
                                if (Modernizr.history) {
                                    w.history.pushState("", d.title, w.location.pathname + w.location.search);
                                } else {
                                    w.location.hash = '';
                                }
                            }
                        }
                    });

                    if (w.location.hash) {
                        $("a[href*='#'].popup").each(function () {
                            if (this.hash === w.location.hash) {
                                $(this).trigger("click");
                            }
                        });
                    }
                },
                gallery: function (el) {
                    var $gallery = $(el);
                    var gallery = {
                        id: $gallery.data("gallery"),
                        img: $("img", el),
                        alt: ''
                    };

                    if (!$gallery.length || !gallery.id || typeof $.magnificPopup !== "object") {
                        return;
                    }

                    if (gallery.img.length && gallery.img.attr("alt") !== "") {
                        gallery.alt = new RegExp(gallery.img.attr("alt").toLowerCase().replace("_", "-"));

                        if (!gallery.alt.test(gallery.img.attr("src"))) {
                            $gallery.attr("title", gallery.img.attr("alt"));
                        }
                    }

                    if (!galleries[gallery.id]) {
                        galleries[gallery.id] = [];
                    }
                    galleries[gallery.id].push($(el).parent()[0]);

                    $.each(galleries, function () {
                        $(this).magnificPopup({
                            mainClass: 'mfp-anim',
                            delegate: "a:visible",
                            type: "image",
                            closeBtnInside: false,
                            gallery: {
                                enabled: true
                            },
                            image: {
                                titleSrc: "title"
                            },
                            removalDelay: 400,
                            callbacks: {
                                beforeOpen: function () {
                                    if (this.st.el.attr('data-popup-class')) {
                                        this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-popup-class');
                                    }
                                }
                            }
                        });
                    });
                },
                onready: function () {
                    app.popup.popup();

                    $("[data-gallery]", $content).each(function () {
                        app.popup.gallery(this);
                    });
                }
            };
        }()),
        form: {
            item: function (item) {
                if ($(item).hasClass("form__item--select")) {
                    if (!$(".form__arrow", item).length) {
                        $("<span class=\"form__arrow\"></span>").insertAfter($("select", item));
                    }
                } else if ($(item).hasClass("form__item--date")) {
                    if (!$(".form__calendar", item).length) {
                        $("<span class=\"form__calendar fi-calendar\"></span>").insertAfter($("input", item));
                    }
                } else if ($(item).hasClass("form__item--rate")) {
                    $(".rating-stars", item).each(function () {
                        $(this).attr("data-rating-stars", $(this).siblings("input[type=hidden]").val());
                    });
                }
            },
            onready: function () {
                $(".form__item").each(function () {
                    app.form.item(this);
                });

                $d.on({
                    "mousemove.rating": function (e) {
                        if ($(e.target).is("i")) {
                            $("i", this).each(function (i) {
                                $(this)[$(e.target).index() >= i ? "addClass" : "removeClass"]("hover");
                            });
                        } else {
                            $("i", this).removeClass("hover");
                        }
                    },
                    "mouseleave.rating": function () {
                        $("i", this).removeClass("hover");
                    },
                    "click.rating": function (e) {
                        var rating;

                        if ($(e.target).is("i")) {
                            rating = $(e.target).index() + 1;
                            $(this).attr("data-rating-stars", rating);
                            $("input[type=hidden]", this).val(rating);
                        }
                        $(this).siblings("input[type=hidden]").val(Math.ceil(e.offsetX / ($(this).width() / 5)));
                    }
                }, ".rating-stars[data-rating-stars]");

                if (typeof $.fn.fileupload === "function") {
                    $(".fileupload").fileupload();
                }
                if (typeof $.fn.floatinglabel === "function") {
                    $(".floatinglabel").floatinglabel();
                }
            }
        },
        validator: {
            setup: (function () {
                if (typeof $.fn.validate !== "function") {
                    return;
                }

                $.extend($.validator.messages, {
                    required: "Pole wymagane",
                    email: "Nieprawidłowy email",
                    number: "Podaj prawidłowową liczbę",
                    digits: "Podaj same cyfry",
                    max: $.validator.format("Podaj wartość mniejszą bądź równą {0}"),
                    min: $.validator.format("Podaj wartość większą bądź równą {0}"),
                    equalTo: "Proszę o podanie tej samej wartości.",
                    maxlength: $.validator.format("Proszę o podanie nie więcej niż {0} znaków."),
                    minlength: $.validator.format("Proszę o podanie przynajmniej {0} znaków.")
                });

                $.validator.addMethod("extension", function (value, element, param) {
                    param = typeof param === "string" ? param : "png,jpeg,jpp,gif";
                    param = param.replace(/,/g, "|");
                    return this.optional(element) || value.match(new RegExp("\\.(" + param + ")$", "i"));
                }, $.validator.format("Dozwolone rozszerzenia: {0}"));

                $.validator.addMethod('filesize', function (value, element, param) {
                    return this.optional(element) || (element.files[0].size <= param);
                }, $.validator.format("Plik jest za duży"));

                $.validator.setDefaults({
                    // submitHandler: function (form) {
                    //     form.submit();
                    // },
                    errorContainer: "",
                    errorLabelContainer: "",
                    invalidHandler: function (e, v) {
                        if (!v.numberOfInvalids()) {
                            return;
                        }

                        $(e.target).addClass("has-error");
                        setTimeout(function () {
                            $(e.target).removeClass("has-error");
                        }, 1000);

                        if (v.settings.invalidCallback) {
                            v.settings.invalidCallback(v);
                        }
                    },
                    invalidCallback: function (v) {
                        if (typeof $.magnificPopup === "object" && $.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
                            return;
                        }

                        app.scrollto($(v.errorList[0].element).closest(".form__item"));
                    },
                    focusInvalid: false,
                    wrapper: "span",
                    errorClass: "has-error",
                    validClass: "is-valid",
                    errorPlacement: function (er, el) {
                        var data = el.data("validate");

                        if (data && data.error && $(data.error).length) {
                            er.appendTo($(data.error));
                        } else if (el.attr("type") === "file" || el.attr("type") === "radio" || el.attr("type") === "checkbox" || el.attr("type") === "range" || el.attr("type") === "hidden") {
                            er.appendTo(el.closest(".form__main").length
                                ? el.closest(".form__main")
                                : el.closest(".form__item"));
                        } else {
                            er.insertAfter(el);
                        }
                        if (er[0].nodeName === "SPAN") {
                            er.addClass("error__wrap");
                        }
                        // return null;
                    },
                    highlight: function (el, ec, vc) {
                        $(el).closest(".form__item").addClass(ec).removeClass(vc);
                    },
                    unhighlight: function (el, ec, vc) {
                        $(el).closest(".form__item").removeClass(ec).addClass(vc);
                    }
                });
            }()),
            validate: function (form, options) {
                var $form = $(form);

                if (typeof $.fn.validate !== "function") {
                    return;
                }

                $.extend(options || {}, $form.data("validator-options") || {});

                return $form.validate(options);
            },
            onready: function () {
                $(".js-validator").each(function () {
                    app.validator.validate(this);
                });
            }
        },
        ajax: {
            form: function (form, options) {
                var $form = $(form);
                var $submit = $("button[type='submit']", form);
                var $notification;

                if (!$form.length || (typeof $.fn.validate === "function" && $form.data("validator") && !$form.valid())) {
                    return;
                }

                $submit.on("click.notification", function () {
                    if ($notification && $notification.length) {
                        if ($notification.data("timer")) {
                            clearTimeout($notification.data("timer"));
                        }
                        if ($notification.hasClass("active")) {
                            $notification.removeClass("active");
                        }
                    }
                });

                options = $.extend(true, {}, {
                    url: podlaski.ajaxurl,
                    // type: $form.attr("method") || "POST",
                    data: {
                        action: "theme_ajax",
                        token: podlaski.token,
                        type: "form"
                    },
                    resetForm: true,
                    beforeSend: function () {
                        $form.preloader();
                        app.vars.sending = true;
                    },
                    success: function (response) {
                        if (response.message) {
                            $form.before("<div class='alert alert--" + (response.success
                                ? "success"
                                : "error") + "'>" + response.message + "</div>");

                            if (response.success) {
                                $form.hide();
                            }
                        } else if ($submit.length) {
                            if (!$submit.data("notification") || !$submit.data("notification").length) {
                                $notification = $("<div>", {
                                    class: "form-notification",
                                    css: {
                                        left: $submit.offset().left + $submit.outerWidth(),
                                        top: $submit.offset().top
                                    },
                                    html: "<span>" + (response.notification || "Zapisano") + "</span>"
                                }).appendTo($b);
                                $submit.data("notification", $notification);
                            } else {
                                $notification = $submit.data("notification");
                            }

                            $notification.data("timer", setTimeout(function () {
                                $notification.addClass("active");
                                $notification.data("timer", setTimeout(function () {
                                    $notification.removeClass("active");
                                }, 3000));
                            }, 100));
                        }
                    },
                    complete: function () {
                        $form.preloader("close");
                        app.vars.sending = false;
                    }
                }, options || {});

                $form.ajaxSubmit(options);
            },
            onready: function () {
                $(".js-ajax-form").on("submit.ajax-form", function (e) {
                    app.ajax.form(this);

                    e.preventDefault();
                });
            }
        },
        isotope: {
            onready: function () {
                var $isotope = $("[data-isotope]", $content);

                if (!$isotope.length || typeof Isotope !== "function" || typeof imagesLoaded !== "function") {
                    return;
                }

                $isotope.each(function () {
                    var $grid = $(this);

                    $grid.imagesLoaded().progress(function () {
                        $grid.isotope('layout');
                    });
                });
            },
            onload: function () {
                var $isotope = $("[data-isotope]", $content);

                if (!$isotope.length || typeof Isotope !== "function") {
                    return;
                }

                $isotope.each(function () {
                    $(this).isotope('layout');
                });
            }
        },
        header: function () {
            var $menu = $(".menu", $header);
            var menu = {};

            menu.svg = d.getElementById("menu_svg");
            menu.snap = Snap(menu.svg);
            menu.bg = Snap.select("#menu_bg");
            menu.get_menu = function () {
                return ["xs", "sm"].indexOf(app.jrespond.getBreakpoint()) >= 0 ? {
                    d: "M490,-50 L190,-50 L190,1000 L490,1000",
                    opacity: "0.9"
                } : {
                    d: "M490-59.442C477.42-61.127,464.643-62,451.7-62C257.463-62,100,132.756,100,373c0,240.243,157.463,435,351.7,435c12.941,0,25.72-0.873,38.3-2.559V-59.442z",
                    opacity: "0.7"
                };
            };

            $(".btn-menu", $header).on("click.menu", function () {
                if ($menu.hasClass("disabled")) {
                    return;
                }

                $menu.addClass("disabled");
                setTimeout(function () {
                    $menu.removeClass("disabled");
                }, 1100);

                $d.trigger({
                    type: "switch",
                    target: this
                }, "menu");
            });

            $d.on("switch:before.menu", function (e) {
                if (e.switch.open) {
                    menu.bg.animate(menu.get_menu(), 700, mina.backout);
                } else {
                    setTimeout(function () {
                        menu.bg.animate({
                            d: "M490,16.388c-6.021-0.739-12.347-1.138-18.878-1.138c-40.221,0-72.823,14.925-72.823,33.335s32.604,33.335,72.823,33.335c6.531,0,12.855-0.399,18.878-1.138V16.388L490,16.388z",
                            opacity: "0.4"
                        }, 700, mina.backin);
                    }, 400);
                }
            });

            app.jrespond.addFunc({
                breakpoint: ["xs", "sm"],
                enter: function () {
                    if (app.vars.switch.menu) {
                        menu.bg.animate(menu.get_menu(), 500, mina.backout);
                    }
                },
                exit: function () {
                    if (app.vars.switch.menu) {
                        menu.bg.animate(menu.get_menu(), 500, mina.backout);
                    }
                }
            });
        },
        content: function () {
            (function () {
                var $heading = $("#heading", $content);

                if (!$heading.length) {
                    return;
                }

                $w.on("resize.heading", function () {
                    $(".swiper", $heading).css("height", ["lg", "xl"].indexOf(app.jrespond.getBreakpoint()) >= 0 ? $w.height() : "");
                });
            }());

            (function () {
                var $timeline = $(".timeline", $content);
                var $timeline_main = $(".timeline__main", $timeline);
                var $timeline_years = $(".timeline__years", $timeline);
                var $timeline_item = $(".timeline-item", $timeline);
                var scenes = {};

                if (!$timeline.length) {
                    return;
                }

                scenes.years = new $.ScrollMagic.Scene({
                    triggerElement: $timeline_main,
                    triggerHook: 0,
                    offset: 0
                })
                    .setClassToggle($timeline_years, "timeline__years--sticky")
                    .on("update", function (e) {
                        $timeline_years[(e.scrollPos > $timeline_main.height() + $timeline_main.offset().top - $timeline_years.outerHeight()) ? "addClass" : "removeClass"]("timeline__years--bottom");
                    })
                    .addTo(controller);

                scenes.items = {};
                $timeline_item.each(function (i, el) {
                    if ($(this).offset().top < $w.height() + $w.scrollTop()) {
                        return;
                    }

                    $(this).addClass("sa-ready");

                    scenes.items[i] = new $.ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 1,
                        offset: 200,
                        reverse: 0
                    })
                        .setClassToggle(this, "sa-visible")
                        .addTo(controller);

                    $(el).css("transition-delay", 0.1 * i + "s");
                });

                app.vars.current_year = $timeline_item.first().data("year");
                $w.on("scroll.years resize.years", function () {
                    var scrolltop = $w.scrollTop(),
                        current;

                    $timeline_item.each(function () {
                        if (scrolltop <= $(this).offset().top + $(this).outerHeight() - 1 && !current) {
                            current = $(this).data("year");
                        }
                    });
                    if (!current) {
                        current = $timeline_item.last().data("year");
                    }
                    if (current !== app.vars.current_year) {
                        app.vars.current_year = current;
                        current = current.toString();
                        $("a", $timeline_years).removeClass("current");
                        $("a[href='#" + current + "']", $timeline_years).addClass("current");
                        $("span", $timeline_years).each(function (i) {
                            if ($(this).text() !== current[i]) {
                                $(this).text(current[i]);
                            }
                        });
                    }
                });

                $("a", $timeline_years).on("click.years", function () {
                    app.scrollto($(".timeline-item[data-year='" + this.hash.replace("#", "") + "']", $timeline).first());
                });
            }());

            (function () {
                var $features = $(".features", $content);
                var $features_item = $(".features-item", $features);
                var scenes = {};

                if (!$features.length) {
                    return;
                }

                scenes.items = {};
                $features_item.each(function (i, el) {
                    scenes.items[i] = new $.ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 1,
                        offset: 200,
                        reverse: 0
                    })
                        .setClassToggle(this, "active")
                        .addTo(controller);

                    $(el).css("transition-delay", 0.1 * i + "s");
                });
            }());

            (function () {
                var $holiday = $(".holiday", $content);
                var $holiday_item = $(".holiday-item", $holiday);
                var offset;
                var scenes = {};

                if (!$holiday.length) {
                    return;
                }

                scenes.items = {};
                $holiday_item.each(function (i, el) {
                    var delay;

                    if (!offset || offset === $(el).offset().top) {
                        offset = $(el).offset().top;
                        delay = i / 10;
                        $(el).data("delay", delay);
                    }

                    if ($(el).offset().top < $w.height() + $w.scrollTop()) {
                        return;
                    }

                    $(el).addClass("sa-ready");

                    scenes.items[i] = new $.ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 1,
                        offset: 200,
                        reverse: 0
                    })
                        .setClassToggle(el, "sa-visible")
                        .addTo(controller);

                    if (delay) {
                        $(el).css("transition-delay", delay + "s");
                    }
                });
            }());

            (function () {
                var $news = $(".news__listing", $content);
                var $news_item = $(".news-item", $news);
                var scenes = {};

                if (!$news.length) {
                    return;
                }

                scenes.items = {};
                $news_item.each(function (i, el) {
                    if ($(el).offset().top < $w.height() + $w.scrollTop()) {
                        return;
                    }

                    $(el).addClass("sa-ready");

                    scenes.items[i] = new $.ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: 1,
                        offset: 200,
                        reverse: 0
                    })
                        .setClassToggle(el, "sa-visible")
                        .addTo(controller);
                });
            }());

            // (function () {
            //     var $graphfb = $("[data-graphfb]", $content);
            //
            //     if (!$graphfb.length) {
            //         return;
            //     }
            //
            //     $graphfb.each(function (i, el) {
            //         $.ajax({
            //             url: podlaski.ajaxurl,
            //             type: "POST",
            //             data: {
            //                 action: "theme_ajax",
            //                 type: "graphfb",
            //                 token: podlaski.token,
            //                 graphfb: $(el).data("graphfb")
            //             },
            //             success: function (response) {
            //                 console.log(response);
            //
            //                 if (response.like) {
            //                     $(".graphfb-like", el).text(response.like);
            //                 }
            //                 if (response.comment) {
            //                     $(".graphfb-comment", el).text(response.comment);
            //                 }
            //             }
            //         });
            //     });
            // }());

            (function () {
                var loaded = {};
                var current_id;
                var timeout;

                if (!podlaski.current || !podlaski.current.id) {
                    return;
                }

                current_id = podlaski.current.id;

                loaded[current_id] = {
                    el: $(".products__loaded[data-loaded='" + current_id + "']", $main),
                    url: podlaski.current.url,
                    title: podlaski.current.title
                };

                function set_category(category_id) {
                    var old_id = current_id;

                    if (app.vars.switch && app.vars.switch.menu) {
                        $d.trigger({
                            type: "switch:close",
                            target: $(".btn-menu", $header)
                        }, "menu");
                    }
                    if (category_id === old_id || !loaded[old_id].el.length) {
                        return;
                    }

                    app.scrollto($b);

                    if (Modernizr.history) {
                        window.history.pushState({category_id: category_id}, loaded[category_id].title, loaded[category_id].url);
                        $("title").text(loaded[category_id].title);
                    }

                    clearTimeout(timeout);
                    loaded[old_id].el
                        .addClass("products__loaded--hidden products__loaded--hidding")
                        .removeClass("products__loaded--current");
                    loaded[category_id].el
                        .addClass("products__loaded--current")
                        .removeClass("products__loaded--hidden");
                    timeout = setTimeout(function () {
                        loaded[old_id].el.addClass("transition-none");
                        loaded[old_id].el.removeClass("products__loaded--hidding");
                        setTimeout(function () {
                            loaded[old_id].el.removeClass("transition-none");
                        }, 100);
                    }, 700);

                    current_id = category_id;
                }

                function load_category(el) {
                    var $el = $(el);
                    var category_id = $(el).data("set-category");
                    var is_categories = current_id === "categories";

                    $.ajax({
                        url: podlaski.ajaxurl,
                        type: "POST",
                        data: {
                            action: "theme_ajax",
                            type: "load",
                            token: podlaski.token,
                            load: category_id
                        },
                        beforeSend: function () {
                            $b.addClass("loading");
                            if (is_categories) {
                                $el.addClass("preloader");
                            }
                            app.vars.sending = true;
                        },
                        success: function (response) {
                            $main.append(response.html);
                            $(".swiper", $main).each(function () {
                                app.swiper.init(this);
                            });
                            app.popup.popup();

                            loaded[category_id] = {
                                el: $(".products__loaded[data-loaded='" + category_id + "']", $main),
                                url: response.url,
                                title: response.title
                            };

                            set_category(category_id);
                        },
                        complete: function () {
                            $b.removeClass("loading");
                            if (is_categories) {
                                $el.removeClass("preloader");
                            }
                            app.vars.sending = false;
                        }
                    });
                }

                $w.on("popstate.set-category", function (e) {
                    if (e.originalEvent.state && e.originalEvent.state.category_id) {
                        set_category(e.originalEvent.state.category_id);
                    }
                });

                w.history.replaceState({
                    category_id: current_id
                }, d.title, d.location.href);

                $d.on("click", "[data-set-category]", function (e) {
                    var category_id = $(this).data("set-category");

                    // if (!$b.hasClass("dev")) {
                    //     return;
                    // }

                    if (loaded[category_id]) {
                        set_category(category_id);
                    } else {
                        load_category(this);
                    }

                    e.preventDefault();
                });
            }());
        },
        footer: function () {
        },
        cookiealert: function () {
            var $cookie_alert;

            if (!app.cookie.get("cookie-alert")) {
                $cookie_alert = $("<div>", {
                    id: 'cookie_alert',
                    class: 'cookie__alert',
                    html: '<div class="cookie__main wrapper"><p>Nasza strona używa ciasteczek (plików cookies oraz podobnych technologii) w celu świadczenia usług, dostosowania serwisu do indywidualnych preferencji użytkowników oraz w celach statystycznych i reklamowych. W każdym momencie można wyłączyć ten mechanizm w ustawieniach przeglądarki. Korzystanie z naszej strony internetowej bez zmiany ustawień dotyczących cookies oznacza, że będą one zapisane w pamięci urządzenia. <button id="cookie_close" class="cookie__close">Nie pokazuj więcej tej informacji</button></p></div></div>'
                }).appendTo($b);

                $d.trigger("cookie_alert");

                $("#cookie_close", $cookie_alert).on("click", function (e) {
                    app.cookie.set("cookie-alert", 1, 365);
                    $cookie_alert.addClass("is-hidden");
                    setTimeout(function () {
                        $d.trigger("cookie_alert");
                    }, parseFloat($cookie_alert.css("transition-duration")) * 1000);

                    e.preventDefault();
                });
            }
        }
    };

    onready = function () {
        app.before();
        app.swiper.onready();
        app.popup.onready();
        app.form.onready();
        app.validator.onready();
        app.ajax.onready();
        app.isotope.onready();
        app.header();
        app.content();
        app.footer();
        // app.cookiealert();
        app.after();

        $w.trigger("resize");
        $w.trigger("scroll");
    };
    onload = function () {
        w.loaded = true;

        app.isotope.onload();

        $w.trigger("resize.heading");
    };

    w.app = $.extend({}, w.app, {
        vars: app.vars,
        jrespond: app.jrespond,
        cookie: app.cookie,
        scrollto: app.scrollto,
        debounce: app.debounce,
        swiper: app.swiper.init,
        popup: {
            popup: app.popup.popup,
            gallery: app.popup.gallery
        },
        form: {
            item: app.form.item
        },
        validate: app.validator.validate,
        ajax: {
            form: app.ajax.form
        }
    });

    $(onready);
    $w.on("load", onload);

}(document, window, jQuery));